import { render, staticRenderFns } from "./GlobalShock.vue?vue&type=template&id=3d37076a&scoped=true&"
import script from "./GlobalShock.vue?vue&type=script&lang=js&"
export * from "./GlobalShock.vue?vue&type=script&lang=js&"
import style0 from "./GlobalShock.vue?vue&type=style&index=0&id=3d37076a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37076a",
  null
  
)

export default component.exports